import React, { useEffect, useState } from "react";
import Shell from "../../Shell/Shell";
import { Grid } from "@mui/material";
import FeedbackPerfomancePresenter from "./FeedbackPerfomancePresenter";
import DTOFeedbackPerfomance from "./DTOFeedbackPerfomance";
import _ from "lodash";
import { useTranslation } from "react-i18next";

interface Prop {
  trans: any;
}
function FeedbackPerfomanceController({ trans}: Prop) {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Shell>
        <Grid container>
          <FeedbackPerfomancePresenter trans={trans} />
        </Grid>
      </Shell>
      <DTOFeedbackPerfomance />
    </>
  );
}
export default FeedbackPerfomanceController;
